import { render, staticRenderFns } from "./MedicalCare.vue?vue&type=template&id=1c8b3738&scoped=true"
import script from "./MedicalCare.vue?vue&type=script&lang=js"
export * from "./MedicalCare.vue?vue&type=script&lang=js"
import style0 from "./MedicalCare.vue?vue&type=style&index=0&id=1c8b3738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8b3738",
  null
  
)

export default component.exports